'use strict';

function tzOffset(d) {
  return d.getTimezoneOffset();
}

module.exports = tzOffset;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/tzOffset.js
// module id = 76
// module chunks = 0